import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithRetry } from './baseQuery';
import type { SupportContext } from '@/utils/supportContext';

export interface SubmitSupportReportArgs extends SupportContext {
  type: 'Bug' | 'Support';
  description: string;
  /** PNG data URL, or undefined when no screenshot is attached. */
  screenshot?: string;
}

export const supportApi = createApi({
  reducerPath: 'supportApi',
  baseQuery: baseQueryWithRetry,
  endpoints: (builder) => ({
    submitSupportReport: builder.mutation<void, SubmitSupportReportArgs>({
      query: (body) => ({
        url: '/support/report',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useSubmitSupportReportMutation } = supportApi;
